import React, { useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './styles.css';

// Kids Church image assets
import kidsHero from '../../assets/hero/kidsHero.jpg';
import kids1 from '../../assets/hero/kids1.jpg';
import kids2 from '../../assets/hero/kids2.jpg';
import kids3 from '../../assets/hero/kids3.jpg';
import kids4 from '../../assets/hero/kids4.jpg';
import kidsAglow from '../../assets/hero/KidsAglow.jpeg';
import kidsDailyDose from '../../assets/hero/kidsDailyDose.png';
import ccLeftKid from '../../assets/hero/cc-left-kid.jpg';
import ccRightKid from '../../assets/hero/cc-right-kid.jpg';

function ChildrensChurch() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const churchPhotos = [
    { src: kids1, caption: 'Creative Drawing & Sketching Time', rotation: '-3deg' },
    { src: kids2, caption: 'Focused Activities & Learning Class', rotation: '4deg' },
    { src: kids3, caption: 'Interactive Quizzes & Writing Circle', rotation: '-2deg' },
    { src: kids4, caption: 'Sunday Study & Fellowship Moments', rotation: '2.5deg' }
  ];

  return (
    <div className="childrens-church-page">
      <Navbar />

      {/* ============ HERO SECTION (LAGUSHON style reference) ============ */}
      <section className="kids-hero">
        <div className="kids-hero-inner">
          <p className="kids-eyebrow-text">✦ BRIGHT BEGINNINGS ✦</p>

          <div className="kids-wordmark-container">
            <h1 className="kids-wordmark-large">
              Children's Ministry
            </h1>
          </div>

          {/* Children image container row with absolute sticker badges overlaying */}
          <div className="kids-hero-portraits-row">
            <div className="kids-side-portrait left-side">
              <img src={ccLeftKid} alt="Child coloring" />
            </div>

            <div className="kids-portrait-container">
              <img src={kidsHero} alt="Happy Child Drawing" className="kids-main-portrait" />
              
              {/* Sticker Overlays */}
              <div className="kid-sticker sticker-grace">Grace</div>
              <div className="kid-sticker sticker-glory">Glory !!</div>
              <div className="kid-sticker sticker-beauty">Beauty</div>
              <div className="kid-sticker sticker-word">Word Of God</div>
              <div className="kid-sticker sticker-joy">Joy</div>
            </div>

            <div className="kids-side-portrait right-side">
              <img src={ccRightKid} alt="Girl writing" />
            </div>
          </div>

          <p className="kids-subtag">growing in grace 🌱</p>
        </div>
      </section>

      {/* ============ MAIN CONTENT CONTAINER (Navbar Size) ============ */}
      <div className="kids-container">
        
        {/* ============ PHOTOS OF THE CHURCH (Visual Journal Stack) ============ */}
        <section className="kids-photos-section">
          <div className="kids-section-header">
            <div className="kids-badge">VISUAL DIARY</div>
            <h2 className="kids-heading">LIFE ON CANVAS: KIDS PHOTOS</h2>
            <p className="kids-desc">Capturing cute moments of praise, laughter, and craftwork in Kids Ministry.</p>
          </div>

          <div className="kids-journal-grid">
            {churchPhotos.map((photo, index) => (
              <div 
                className={`kids-photo-card card-style-${index + 1}`} 
                key={index} 
                style={{ transform: `rotate(${photo.rotation})` }}
              >
                <div className="kids-tape-strip"></div>
                <div className="kids-img-box">
                  <img src={photo.src} alt={photo.caption} className="kids-journal-img" />
                </div>
                <div className="kids-caption">{photo.caption}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ============ KIDS PROGRAMS (The Flyer Bulletin Board) ============ */}
        <section id="programs" className="kids-programs-section">
          <div className="kids-section-header">
            <div className="kids-badge">WEEKLY SCHEDULES</div>
            <h2 className="kids-heading">KIDS PROGRAMS & SCHEDULES</h2>
            <p className="kids-desc">We gather weekly to learn, worship, and play in a fun-filled community atmosphere.</p>
          </div>

          <div className="kids-bulletin-grid">
            
            {/* Sunday Kids Connect - Kids Aglow */}
            <div className="kids-flyer flyer-sunday-kids">
              <div className="kids-flyer-tape"></div>
              <div className="kids-flyer-badge">KIDS AGLOW series</div>
              <h3 className="kids-flyer-title">KIDS AGLOW</h3>
              <p className="kids-flyer-time">🕒 9:30 AM | Every Sunday</p>
              
              {/* Program Thumbnail */}
              <div className="kids-flyer-thumbnail">
                <img src={kidsAglow} alt="Kids Aglow Service" />
              </div>

              <div className="kids-flyer-details lines-style">
                <p>• Beloved faith-focused children's educational series</p>
                <p>• Scriptural teachings & memory verses</p>
                <p>• Nurturing biblical character values</p>
                <p>• Fun interactive faith lessons</p>
              </div>

              <div className="kids-flyer-footer">FAITH EDUCATION</div>
            </div>

            {/* Wednesday Kids Club - Daily Dose */}
            <div className="kids-flyer flyer-wednesday-kids">
              <div className="kids-flyer-tape-diagonal"></div>
              <div className="kids-flyer-badge">DAILY DOSE devotion</div>
              <h3 className="kids-flyer-title">DAILY DOSE</h3>
              <p className="kids-flyer-time">🕒 Every Morning</p>
              
              {/* Program Thumbnail */}
              <div className="kids-flyer-thumbnail">
                <img src={kidsDailyDose} alt="Daily Dose Reading Segment" />
              </div>

              <div className="kids-flyer-details blueprint-style">
                <p className="bp-lbl">OBJECTIVE:</p>
                <p className="bp-txt">Access daily reading materials like Rhapsody of Realities for Kids through the official Kiddies Loveworld platform.</p>
                
                <p className="bp-lbl">PLATFORM:</p>
                <p className="bp-txt highlight-txt">Kiddies Loveworld Web & Mobile App.</p>
              </div>

              <div className="kids-flyer-footer stamp-style">DAILY DEVOTIONAL</div>
            </div>

          </div>
        </section>

      </div>
    </div>
  );
}

export default ChildrensChurch;
